// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyFeed_container__17zfb"};